import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from '@wegroup/design-system';
import React from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { prefilledInputComponentStyling } from '../../../../../../../../flows/src/constants/InputComponentStyling';

interface Props {
  name?: string;
  value?: string;
  onChange: (street?: string) => void;
  onBlur?: () => void;
  error?: FieldError;
  isDisabled?: boolean;
  isPrefilled?: boolean;
}

const ManualStreet: React.FC<Props> = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  isDisabled,
  isPrefilled,
}) => {
  const { t } = useTranslation();

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel>{t('STREET')}</FormLabel>
      <Input
        name={name}
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        isDisabled={isDisabled}
        {...(value != null &&
          isPrefilled && { sx: prefilledInputComponentStyling })}
      />
      {error?.message && (
        <FormErrorMessage>{t(error.message)}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default ManualStreet;
